import { render, staticRenderFns } from "./cert-guide-poster.vue?vue&type=template&id=5f8e3c52&scoped=true"
import script from "./cert-guide-poster.vue?vue&type=script&lang=js"
export * from "./cert-guide-poster.vue?vue&type=script&lang=js"
import style0 from "./cert-guide-poster.vue?vue&type=style&index=0&id=5f8e3c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e3c52",
  null
  
)

export default component.exports